

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.DVYxspf3.js","_app/immutable/chunks/disclose-version.Dr32KdXi.js","_app/immutable/chunks/index-client.7IhS7CEJ.js","_app/immutable/chunks/legacy.DQ3C9O0k.js","_app/immutable/chunks/render.CrlMBPJT.js","_app/immutable/chunks/lifecycle.ZIc96j8x.js","_app/immutable/chunks/entry.CGbGG2JM.js","_app/immutable/chunks/index.xUn_SZbm.js"];
export const stylesheets = [];
export const fonts = [];
